import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { ShieldWarning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function ChangePassword() {
  const { user, changePassword, formatApiError } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("Passwords do not match");
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    setBusy(true);
    try {
      await changePassword(cur, pw);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-6">
      <div className="w-full max-w-md bg-white rounded-lg p-8 shadow-xl">
        <div className="flex items-center gap-3 mb-2 text-amber-600">
          <ShieldWarning size={28} weight="fill" />
          <h2 className="font-heading font-bold text-xl tracking-tight text-slate-900">Set a new password</h2>
        </div>
        <p className="text-sm text-slate-500 mb-6">
          Welcome, {user?.name}. For security you must change your password before continuing.
        </p>
        {error && <div className="mb-4 bg-red-50 border-l-4 border-red-500 p-3 rounded-r-md text-red-800 text-sm" data-testid="change-pw-error">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          {[["Current password", cur, setCur, "current-pw"], ["New password", pw, setPw, "new-pw"], ["Confirm new password", pw2, setPw2, "confirm-pw"]].map(([label, val, set, tid]) => (
            <div key={tid}>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
              <input data-testid={tid} type="password" required value={val} onChange={(e) => set(e.target.value)}
                className="mt-1 w-full px-3 py-2.5 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-slate-900 outline-none" />
            </div>
          ))}
          <Button data-testid="change-pw-submit" type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800 text-white h-11">
            {busy ? "Saving…" : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
